import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const DocumentFilter = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 25 25"
      fill="none"
      {...rest}
    >
      <path
        opacity="0.4"
        d="M3.91431 2.08154H12.8143C13.5543 2.08154 14.1643 2.69155 14.1643 3.43155V4.91153C14.1643 5.45153 13.8243 6.12155 13.4943 6.46155L10.5944 9.02155C10.1944 9.36155 9.92432 10.0315 9.92432 10.5715V13.4716C9.92432 13.8716 9.65433 14.4116 9.31433 14.6216L8.37433 15.2315C7.49433 15.7715 6.2843 15.1615 6.2843 14.0815V10.5115C6.2843 10.0415 6.01432 9.43155 5.74432 9.09155L3.18433 6.39154C2.84433 6.05154 2.57434 5.45153 2.57434 5.04153V3.49155C2.56434 2.69155 3.17431 2.08154 3.91431 2.08154Z"
        stroke="#9759CC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.56445 12.0815V15.0815C2.56445 20.0815 4.56445 22.0815 9.56445 22.0815H15.5645C20.5645 22.0815 22.5645 20.0815 22.5645 15.0815V9.08154C22.5645 5.96154 21.7844 4.00154 19.9744 2.98154C19.4644 2.69154 18.4445 2.47153 17.5145 2.32153"
        stroke="#9759CC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M13.5645 13.0815H18.5645"
        stroke="#9759CC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.5645 17.0815H18.5645"
        stroke="#9759CC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

DocumentFilter.displayName = 'DocumentFilter';
